export const dev = false // TODO change this to proper env

// Dev
export const stakingAddress = '0x1a0e973f0566fbe1bd01c2cd8bb17763035ee541'
export const rewardAddress = '0xf8867a8946582d7227164f6c70cf115cc93cbde5'
export const tokenAddress = '0xbd40e2c830e1066d20e72a0cf2e55a19398752f6'

// Prod
// export const stakingAddress = '0x372c552f0796bc6bd7235ce0c97a291b7017a707'
// export const rewardAddress = '0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56'
// export const tokenAddress = '0xddD9d7D280c78b564C55BEb26562E367d4b9Bd8a'
